import * as uniqid from 'uniqid';
import State from '../../application/core/State';
import Event from '../../application/core/Event';
import EstimationChangeRequested from '../../application/estimations/events/EstimationChangeRequested';
import Notification from '../../application/core/Notification';
import NotificationProduced from '../../application/core/events/NotificationProduced';
import EstimationChangeConfirmed from '../../application/estimations/events/EstimationChangeConfirmed';

// todo test
export default (state: State, event: EstimationChangeRequested): Event[] => {
    if (event.shouldValidate) {
        const validValue: number = Math.ceil(event.value / event.product.packageSize) * event.product.packageSize;
        if (validValue === event.value) {
            return [
                new EstimationChangeConfirmed(
                    state.user.discountRate,
                    event.product,
                    event.sku,
                    event.variantCode,
                    event.month,
                    event.value
                )
            ];
        } else {
            return [
                new NotificationProduced(
                    new Notification(uniqid(), {
                        message: 'Your quantity will be automatically rounded up to nearest package size'
                    })
                ),
                new EstimationChangeConfirmed(state.user.discountRate, event.product, event.sku, event.variantCode, event.month, validValue)
            ];
        }
    } else {
        return [
            new EstimationChangeConfirmed(state.user.discountRate, event.product, event.sku, event.variantCode, event.month, event.value)
        ];
    }
};



// WEBPACK FOOTER //
// ./src/domain/estimations/roundEstimation.ts